import { createWebHashHistory, createRouter } from 'vue-router'


/* Layout */
import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
  {
    path: '',
    name: 'Layout',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/workbench/index.vue'),
        meta: { title: '工作台', icon: 'dashboard', sidebar: true },
      },
      {
        path: '/approve',
        name: 'WorkbenchApprove',
        component: () => import('@/views/workbench/approve/index.vue'),
        meta: { title: '电站审核', sidebar: false, activeMenu: '/index' },
      },
      {
        path: '/approve/success',
        name: 'WorkbenchApproveSuccess',
        component: () => import('@/views/workbench/approve/ApproveSuccessPage.vue'),
        meta: { title: '投运成功', sidebar: false, activeMenu: '/my-powerStation' },
      },
      {
        path: '/om',
        name: 'OM',
        component: () => import('@/views/workbench/OM/index.vue'),
        meta: { title: '工作台(运维)', icon: 'dashboard', sidebar: false },
      },
      {
        path: '/my-powerStation',
        name: 'myPowerStation',
        component: () => import('@/views/my-powerStation/index.vue'),
        meta: { title: '我的电站', icon: 'stations', sidebar: true },
      },
      {
        path: '/station-monitor',
        name: 'StationMonitor',
        component: () => import('@/views/station-monitor/index.vue'),
        redirect: '/station-monitor/summary',
        meta: { title: '实时监控', icon: 'monitor', sidebar: true },
        children: [
          {
            path: 'summary',
            name: 'StationSummary',
            component: () => import('@/views/station-monitor/summary/index.vue'),
            meta: { title: '监控总览', icon: 'monitor-summary', sidebar: true },
          },
          {
            path: 'detail',
            name: 'Monitor',
            component: () => import('@/views/station-monitor/detail/index.vue'),
            meta: { title: '站级监控', icon: 'monitor-detail', sidebar: true },
          },
        ]
      },
      // {
      //   path: '/monitor',
      //   component: () => import('@/views/monitor/index.vue'),
      //   name: 'Monitor',
      //   meta: { title: '电站监控', icon: 'monitor', sidebar: true },
      //   children: []
      // },
      {
        path: '/ai',
        component: () => import('@/views/ai/index.vue'),
        name: 'Ai',
        meta: { title: '', icon: 'ai', sidebar: false },
        children: []
      },
      {
        path: '/business-operations',
        name: 'BusinessOperations',
        component: () => import('@/views/business-operations/index.vue'),
        meta: { title: '运营管理', icon: 'business', sidebar: true },
        redirect: '/business-operations/summary',
        children: [
          {
            path: 'summary',
            name: 'BusinessOperationsSummary',
            component: () => import('@/views/business-operations/summary/index.vue'),
            meta: { title: '运营总览', icon: 'business-summary', sidebar: true },
          },
          {
            path: 'detail',
            name: 'BusinessOperationsDetail',
            component: () => import('@/views/business-operations/detail/index.vue'),
            meta: { title: '运营详情', icon: 'business-detail', sidebar: true },
          },
        ]
      },
      {
        path: '/business-operations/station/:stationId',
        name: 'BusinessOperationsStation',
        component: () => import('@/views/station-monitor/detail/index.vue'),
        meta: { title: '单站视角', icon: 'business', sidebar: false, activeMenu: '/business-operations' },
      },
      {
        path: '/it-operations',
        name: 'ITOperations',
        component: () => import('@/views/it-operations/index.vue'),
        meta: { title: '运维管理', icon: 'it', sidebar: true },
        redirect: '/it-operations/multi/overview',
        children: [
          {
            path: 'multi',
            name: 'Multi',
            component: () => import('@/views/it-operations/summary/index.vue'),
            meta: { title: '多站运维', icon: 'it-multi', sidebar: true },
            children: [
              {
                path: 'overview',
                name: 'ITOverview',
                component: () => import('@/views/it-operations/summary/tabs/overview/index.vue'),
                meta: { title: '运维总览', icon: 'it-overview', sidebar: true },
              },
              {
                path: 'stations',
                name: 'Stations',
                component: () => import('@/views/it-operations/summary/tabs/stations/index.vue'),
                meta: { title: '电站管理', icon: 'stations', sidebar: true },
              },
              {
                path: 'alarm',
                name: 'Alarm',
                component: () => import('@/views/it-operations/summary/tabs/alarm/index.vue'),
                meta: { title: '告警中心', icon: 'alarm', sidebar: true },
              },
              {
                path: 'ota',
                name: 'OTA',
                component: () => import('@/views/it-operations/summary/tabs/ota/index.vue'),
                meta: { title: 'OTA升级', icon: 'ota', sidebar: true },
              },
              {
                path: 'investors',
                name: 'Investors',
                component: () => import('@/views/it-operations/summary/tabs/investors/index.vue'),
                meta: { title: '客户管理', icon: 'investors', sidebar: true },
              },
              {
                path: 'data-analysis',
                name: 'ITDataAnalysis',
                component: () => import('@/views/station-monitor/detail/components/data-analysis/index.vue'),
                meta: { title: '数据分析', icon: 'it', sidebar: true },
              },
              {
                path: 'alarm-analysis',
                name: 'AlarmAnalysis',
                component: () => import('@/views/it-operations/summary/tabs/alarm-analysis/index.vue'),
                meta: { title: '告警分析', icon: 'alarm', sidebar: true },
              },
            ]
          },
          {
            path: 'detail',
            name: 'ITDetail',
            component: () => import('@/views/it-operations/detail/index.vue'),
            meta: { title: '单站运维', icon: 'it-detail', sidebar: true },
          },
          {
            path: 'station/add',
            name: 'ITStationAdd',
            component: () => import('@/views/it-operations/station-add/index.vue'),
            meta: { title: '新增电站', icon: 'stations', sidebar: true, activeMenu: '/it-operations/multi/stations' },
          },
        ],




      },
      {
        path: '/system-manager',
        name: 'SystemManager',
        component: () => import('@/views/system-manager/index.vue'),
        meta: { title: '系统管理', icon: 'system', sidebar: true },
        redirect: '/system-manager/config',
        children: [
          {
            path: 'config',
            name: 'Config',
            component: () => import('@/views/system-manager/config/index.vue'),
            meta: { title: '业务配置', icon: 'config', sidebar: true },
          },
          {
            path: 'menu',
            name: 'Menu',
            component: () => import('@/views/system-manager/menu/index.vue'),
            meta: { title: '菜单管理', icon: 'menu', sidebar: true },
          },
          {
            path: 'role',
            name: 'Role',
            component: () => import('@/views/system-manager/role/index.vue'),
            meta: { title: '角色管理', icon: 'role', sidebar: true },
          },
          {
            path: 'org',
            name: 'Org',
            component: () => import('@/views/system-manager/org/index.vue'),
            meta: { title: '组织管理', icon: 'org', sidebar: true },
          },
          {
            path: 'user',
            name: 'User',
            component: () => import('@/views/system-manager/user/index.vue'),
            meta: { title: '用户管理', icon: 'user', sidebar: true },
          },
          {
            path: 'operlog',
            name: 'Operlog',
            component: () => import('@/views/system-manager/operlog/index.vue'),
            meta: { title: '操作日志', icon: 'operlog', sidebar: true },
          },
          {
            path: 'logininfor',
            name: 'Logininfor',
            component: () => import('@/views/system-manager/logininfor/index.vue'),
            meta: { title: '登录日志', icon: 'logininfor', sidebar: true },
          },
        ]
      },
      {
        path: '/personal',
        name: 'Personal',
        component: () => import('@/views/personal/index.vue'),
        meta: { title: '个人中心', icon: 'user', sidebar: true },
        redirect: '/personal/info',
        children: [
          {
            path: 'info',
            name: 'PersonalInfo',
            component: () => import('@/views/personal/userinfo/index.vue'),
            meta: { title: '个人信息', icon: 'user', sidebar: false },
          },
          {
            path: 'stations',
            name: 'PersonalStations',
            component: () => import('@/views/personal/stations/index.vue'),
            meta: { title: '个人电站', icon: 'stations', sidebar: false },
          },
        ]
      }
    ]
  }
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [


]

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
});

export default router;
